import { useTranslation } from "react-i18next";

interface DeviceAttributionProps {
  deviceName?: string | null;
  compact?: boolean;
}

/**
 * Whether `device_name` indicates a Garmin device.
 * Case-insensitive substring match on "garmin" per intervals.icu guidance.
 */
export function isGarminDevice(deviceName?: string | null): boolean {
  if (!deviceName) return false;
  return deviceName.toLowerCase().includes("garmin");
}

/**
 * Displays the originating device for an activity.
 * Required by intervals.icu API Terms (Section 1.1) for Garmin-sourced data.
 *
 * compact = small inline pill ("Garmin Edge 530")
 * default = labelled row ("Source: Garmin Edge 530")
 */
export function DeviceAttribution({
  deviceName,
  compact = false,
}: DeviceAttributionProps) {
  const { t } = useTranslation();
  if (!deviceName) return null;
  const garmin = isGarminDevice(deviceName);

  if (compact) {
    return (
      <span
        className={`device-attribution device-attribution--compact${
          garmin ? " is-garmin" : ""
        }`}
        title={garmin ? t("device_attribution.garmin_tooltip") : deviceName}
      >
        {deviceName}
      </span>
    );
  }

  return (
    <div className={`device-attribution${garmin ? " is-garmin" : ""}`}>
      <span className="device-attribution__label">
        {t("device_attribution.source_label")}
      </span>
      <span className="device-attribution__name">{deviceName}</span>
    </div>
  );
}
